export default "__VITE_ASSET__5e2143fd__"